// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	//force double click parent menu
/*	jQuery('.navbar .dropdown > a').click(function() {
	 if (!jQuery(this).hasClass("parent-clicked")) {
	 	//console.log('click');
	    jQuery(this).addClass("parent-clicked");
	  } else {
	    location.href = this.href;
	  }
	});*/

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();




function button(e) {
	let cardFeature = document.getElementsByClassName(e);
	if (cardFeature.length > 0 ){

		for (let x=0; cardFeature.length > x; x++) {
			let card = cardFeature[x].getElementsByClassName('card-item-inner');
		
			for (var i=0; i < card.length; i++){
				let url = card[i].querySelectorAll('a');
				let href = url[0].href;

				card[i].setAttribute('title', href); //adds hover tooltip
				//card[i].setAttribute('data-href', href);
				card[i].setAttribute('role', 'button'); //changes div role to button for screen readers
				card[i].setAttribute('tabIndex', '0'); //allows to divs to be tabbed through as if they were links/buttons

				card[i].addEventListener('keydown', function(e) { //for keyboard users, adds link functionality 
					if (e.key === 'Enter' || e.key == ' ') {					
						if( href.includes('oharetipline') || href.includes('lndo')) {
							window.location = href;
						} else {
							window.open(href, "_blank");
						}
					}
				});

				card[i].addEventListener('click', function() {
					//new tab for links that do not contain ig domain or lando
					if( href.includes('oharetipline') || href.includes('lndo')) {
						window.location = href;
					} else {
						window.open(href, "_blank");
					}
				});

				//url[0].setAttribute('href', 'javascript:void(0)');
				url[0].setAttribute('tabIndex', '-1');
			}

		}
	}

	return e;
}


/* make only certain cards "whole div clickable"
ex: publications card has multi-links, news could
possibly have a link in the summary, so NOPE */
button('card-feature-bg-photos');
button('card-feature');
button('dashboard-anchors');
button('dashboard-grid');
button('leadership-anchors');
button('leadership-grid');
button('publication-related');
button('billboard-buttons'); 


// button('stacked-link-cards');




